import { LangCode } from "@/lib/gql/__generated__/graphql";

import { useEditedQuestionIndicator, useErrorQuestionIndicator } from "../../../../_shared/hooks";
import { useSendCustomMailSettingForCheckInAfter_01days } from "../../../api/send-custom-mail-setting/check-in-after-01-days";
import { MailTemplateItem } from "../_shared/mail-template-item";

import type { BasicCustomMailSettingFormData } from "../../../schema";
import type { UseFormReturn } from "react-hook-form";

type Props = {
	form: UseFormReturn<BasicCustomMailSettingFormData>;
	hotelID: string;
	hotelEmailAddress: string;
};

export const ForCheckOutRemind = ({ form, hotelID, hotelEmailAddress }: Props) => {
	const {
		watch,
		setValue,
		formState: { errors },
	} = form;

	const checkOutOption = watch("forReservation.atCheckOutAfter_01days.shouldSendEmail");
	const checkOutValue = watch("forReservation.atCheckOutAfter_01days.text");

	// 値が入っているかどうかを監視（設定した項目がある場合に青丸を表示）
	useEditedQuestionIndicator("チェックアウト翌日", Boolean(checkOutValue) || checkOutOption);

	// バリデーションエラーがある場合に赤丸を表示
	useErrorQuestionIndicator("チェックアウト翌日", Boolean(errors.forReservation?.atCheckOutAfter_01days?.text));

	// テストメール送信ハンドラーを追加
	const { sendTestMailAtCheckInAfter01Days } = useSendCustomMailSettingForCheckInAfter_01days();

	const handleSendTestEmailForCheckOut = async ({ email }: { email: string }) => {
		await sendTestMailAtCheckInAfter01Days({
			mailAddress: email,
			customMessage: checkOutValue || "",
			id: hotelID,
			langCode: LangCode.Default,
		});
	};
	return (
		<div className="space-y-6">
			<div className="ml-2">
				{/* チェックアウト翌日 */}
				<MailTemplateItem
					hidePreviewButton={false}
					label={"チェックアウト翌日"}
					dialogTitle={"チェックアウト翌日"}
					value={checkOutValue || ""}
					errorMessage={errors.forReservation?.atCheckOutAfter_01days?.text?.message || ""}
					handleChange={(value) =>
						setValue(
							"forReservation.atCheckOutAfter_01days.text", //
							value,
							{ shouldDirty: true, shouldValidate: true },
						)
					}
					sendTestEmail={handleSendTestEmailForCheckOut}
					lang={LangCode.Default}
					hotelEmailAddress={hotelEmailAddress}
					radioOptions={[
						{ label: "送信する", value: true, isSelected: checkOutOption },
						{ label: "送信しない", value: false, isSelected: !checkOutOption },
					]}
					onRadioChange={(value) =>
						setValue("forReservation.atCheckOutAfter_01days.shouldSendEmail", value, {
							shouldDirty: true,
							shouldValidate: true,
						})
					}
				/>
			</div>
		</div>
	);
};
